import BadmintonStats from "./BadmintonStats";
export default BadmintonStats;
